import { getPseudonyms } from 'Redux/Query';

export const getPseudonymByModuleAndCareProvider = ({moduleId, careProviderId}) => (state) => {
    const pseudonyms = getPseudonyms(state);
    return pseudonyms.find(pseudonym => pseudonym?.module?.id === moduleId && pseudonym?.careProvider?.id === careProviderId);
};
